var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"building-edit-unity-viewer-tab"},[(_vm.buildingHasModel)?_c('unity-viewer',{attrs:{"building-id":_vm.building.id}}):_c('div',[_vm._v(" Dit bouwnummer heeft nog geen 3D model ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }